<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let label = null
    export let text = ''
    export let value = ''

    export let options = []
    export let required = true
    export let style = ''

    function onChange() {
        dispatch('select', value)
    }

</script>

<!-- svelte-ignore a11y-no-onchange -->

<div class="field app-select-field" style={ style }>
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <div class="select is-fullwidth">
            <select bind:value={value} on:change={onChange} on:change { required } >
                <option value="">{ text || 'Selecciona una opción'}</option>
                {#each options as option}
                    <option value="{ option.value }">{ option.text }</option>
                {/each}
            </select>
        </div>
    </div>
</div>

<style>
    .app-select-field {
        width: 100%;
        min-width: 0;
    }

    .app-select-field .control {
        width: 100%;
    }
</style>